import { useIntl } from "react-intl";
import { CourseMaterial } from "./coursesLoader";
import { Book } from "common/api/decimal/methods/course";

export default function useAccessDuration({
  accessDuration,
}: Book | CourseMaterial) {
  const intl = useIntl();
  if (accessDuration === undefined || accessDuration === null) {
    return null;
  }
  return accessDuration === 0
    ? intl.formatMessage({ defaultMessage: "Lifetime Access" })
    : intl.formatMessage(
        { defaultMessage: "{duration} Day License" },
        { duration: accessDuration }
      );
}
